module.exports = __webpack_public_path__ + "db934f6aac7e30554a520794064fd5b5.jpg";